import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("chatbots.projects.title_agent"))),
      ]),
      _vm.total_projects > 0
        ? [
            _c(
              "actions-component",
              { attrs: { class_table: _vm.getClassTable } },
              [
                _c(
                  "template",
                  { slot: "description" },
                  [
                    _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                      _vm._v(
                        _vm._s(_vm.$t("chatbots.projects.agent_description")) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "template",
                  { slot: "actions" },
                  [
                    _c(
                      VBtn,
                      {
                        staticClass: "ml-1 btn-inca-secondary",
                        attrs: { outlined: "", dense: "" },
                        on: {
                          click: function ($event) {
                            return _vm.goCreatePage("dev")
                          },
                        },
                      },
                      [
                        _c(VIcon, { attrs: { small: "" } }, [
                          _vm._v("icon-add"),
                        ]),
                        _vm._v(_vm._s(_vm.$t("chatbots.projects.create_dev"))),
                      ],
                      1
                    ),
                    _c(
                      VBtn,
                      {
                        staticClass: "ml-1 btn-inca-secondary",
                        attrs: { dense: "", outlined: "" },
                        on: { click: _vm.onEnableFilter },
                      },
                      [
                        _vm.filter_enabled
                          ? _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-filter-off-outline"),
                            ])
                          : _vm._e(),
                        !_vm.filter_enabled
                          ? _c(VIcon, { attrs: { small: "" } }, [
                              _vm._v("mdi-filter-outline"),
                            ])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              VRow,
              {
                class: {
                  "flex-filter":
                    _vm.size_screen == "sm" || _vm.size_screen == "xs",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex-filter-order1",
                    class: _vm.getClassTable,
                  },
                  [
                    _c(
                      VCard,
                      [
                        _c(VDataTable, {
                          staticClass: "table-inca",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.filteredData,
                            "hide-default-footer": "",
                            "items-per-page": _vm.pagination.limit,
                            page: _vm.pagination.current,
                            "sort-by": ["created_date_desc"],
                            "sort-desc": [true],
                          },
                          on: {
                            pagination: function ($event) {
                              _vm.pagination.total = $event.itemsLength
                            },
                            "update:page": function ($event) {
                              return _vm.$set(_vm.pagination, "current", $event)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item.connections",
                                fn: function (ref) {
                                  var item = ref.item
                                  return _vm._l(
                                    item.connections,
                                    function (con) {
                                      return _c(
                                        VChip,
                                        {
                                          staticClass: "mb-1 mr-1",
                                          attrs: { small: "", dense: "" },
                                        },
                                        [
                                          _vm.isConnectionPlayground(con)
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: _vm.getHref(
                                                      item,
                                                      con
                                                    ),
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getConnectionName(con)
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getConnectionName(con)
                                                  )
                                                ),
                                              ]),
                                          _vm.isConnectionPlayground(con)
                                            ? _c(
                                                VIcon,
                                                {
                                                  attrs: {
                                                    small: "",
                                                    dense: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onOpenPlayground(
                                                        con,
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-open-in-new")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    }
                                  )
                                },
                              },
                              {
                                key: "item.chatbot",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.getChatbotName(item.chatbot))
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.chatbot_type",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.chatbotTypeText[
                                            item.chatbot_type
                                          ] || item.chatbot_type
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.env",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.chatbotEnvText[item.env] ||
                                            item.env
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          disabled: !_vm.isAdministrator(item),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditProject(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-edit"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onViewProject(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-view"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    item.created_user == _vm.userInfo.email
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onRemoveProject(item)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("icon-delete")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.private_access
                                      ? _c(
                                          VBtn,
                                          {
                                            staticClass: "btn-icon-inca",
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEditPermission(
                                                  item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VIcon,
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-account-multiple")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    item.env == "prod" &&
                                    !item.dev_project_id &&
                                    _vm.userHasRole("support_developer")
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onGenerateSandbox(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "mdi-flask-outline"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Generar sandbox"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasRole(
                                      _vm.rolesINCA.SERVICE_MANAGER
                                    )
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onChangeOwner(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "mdi-account-switch-outline"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Cambiar propietario"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasRole("support_developer")
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onMigrateProject(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "mdi-swap-horizontal"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v("Migrar projecto"),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.userHasRole("support_developer")
                                      ? _c(
                                          VTooltip,
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function (ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        VBtn,
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "btn-icon-inca",
                                                              attrs: {
                                                                icon: "",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onChangeBot(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(VIcon, [
                                                            _vm._v(
                                                              "mdi-robot-outline"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("Cambiar bot")])]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            895576847
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("pagination-vue", {
                      attrs: { pagination: _vm.pagination },
                    }),
                  ],
                  1
                ),
                _vm.filter_enabled
                  ? _c(
                      "div",
                      {
                        staticClass: "col-md-3 col-sm-12 mb-3",
                        class: {
                          "pl-0":
                            _vm.size_screen == "md" || _vm.size_screen == "lg",
                        },
                      },
                      [
                        _c(
                          VCard,
                          { staticClass: "filters-inca" },
                          [
                            _c(
                              VCardTitle,
                              {
                                staticClass: "pointer pb-0",
                                on: {
                                  click: function ($event) {
                                    _vm.collapse_filter = !_vm.collapse_filter
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                            ),
                            _c(
                              VCardText,
                              { staticClass: "pa-2 pt-0" },
                              [
                                _c(
                                  VRow,
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _vm.userInfo.userRoles &&
                                        _vm.userInfo.userRoles.includes(
                                          "ml_steward"
                                        )
                                          ? _c("organizacion-component", {
                                              attrs: {
                                                custom_orgs: _vm.list_orgs,
                                                show_all: false,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.listProjects()
                                                },
                                              },
                                              model: {
                                                value: _vm.domain_selected,
                                                callback: function ($$v) {
                                                  _vm.domain_selected = $$v
                                                },
                                                expression: "domain_selected",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VSelect, {
                                          attrs: {
                                            label: _vm.$t(
                                              "my_tasks.environment"
                                            ),
                                            items: _vm.list_env,
                                            outlined: "",
                                            dense: "",
                                          },
                                          model: {
                                            value: _vm.filters.env,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.filters, "env", $$v)
                                            },
                                            expression: "filters.env",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(VTextField, {
                                          attrs: {
                                            label: _vm.$t(
                                              "data_quality.dataplex.profiling.fields.name"
                                            ),
                                            placeholder: _vm.$t(
                                              "data_quality.dataplex.profiling.fields.name"
                                            ),
                                            outlined: "",
                                            dense: "",
                                          },
                                          model: {
                                            value: _vm.filters.project_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "project_name",
                                                $$v
                                              )
                                            },
                                            expression: "filters.project_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "text-right",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "default mr-1",
                                            attrs: { outlined: "" },
                                            on: { click: _vm.onLimpiar },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                        ),
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "primary ",
                                            on: { click: _vm.onSearch },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("btns.search"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        : [
            _c(VRow, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    VCard,
                    [
                      _c(VCardSubtitle),
                      _c(
                        VContainer,
                        { staticClass: "fluid justify-center" },
                        [
                          _c(
                            VRow,
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                VCol,
                                {
                                  staticClass: "col-md-10 col-xl-8 col-12",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("grid-card-component", {
                                    attrs: { "custom-cards": _vm.cards },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
      _c(
        "DialogsComponent",
        {
          ref: "dialogProject",
          attrs: { title: _vm.dialog_agent_title, width: 1000 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("grid-card-component", {
                attrs: { "custom-cards": _vm.cards },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_REMOVE_PROJECT",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar el proyecto?",
        },
        on: { onConfirm: _vm.onConfirmRemoveProject },
      }),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_CHANGE_TO_PROD",
        attrs: {
          title: "Confirmación pasar a versión final",
          text: "¿Esta seguro de pasar de versión de prueba a versión final?",
        },
        on: { onConfirm: _vm.onConfirmChangeToProd },
      }),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_GENERATE_SANDBOX",
        attrs: {
          title: "Confirmación generar sandbox",
          text: "¿Está seguro de generar un entorno sandbox para este proyecto?",
        },
        on: { onConfirm: _vm.onConfirmGenerateSandbox },
      }),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_PERMISSIONS_PROJECT",
          attrs: { title: "Permisos", width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("project-permission-component", {
                model: {
                  value: _vm.permissions,
                  callback: function ($$v) {
                    _vm.permissions = $$v
                  },
                  expression: "permissions",
                },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca",
                  attrs: { rounded: "", color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.upsertPermissions()
                    },
                  },
                },
                [_vm._v(_vm._s("Guardar Cambios"))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: "owner_dialog",
          attrs: { title: "Cambiar propietario", width: 800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(VForm, { ref: "formDialog" }),
              _c(
                VRow,
                { attrs: { justify: "center" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v("Nuevo propietario"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          outlined: "",
                          dense: "",
                          "hide-details": "auto",
                          rules: [
                            function (v) {
                              return !!v || _vm.$t("my_tasks.modals.required")
                            },
                            function (v) {
                              return (
                                /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(
                                  v
                                ) || _vm.$t("my_tasks.modals.email_invalid")
                              )
                            },
                          ],
                        },
                        model: {
                          value: _vm.new_owner,
                          callback: function ($$v) {
                            _vm.new_owner = $$v
                          },
                          expression: "new_owner",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                { attrs: { color: "primary" }, on: { click: _vm.changeOwner } },
                [
                  _c(VIcon, { staticClass: "mr-1", attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v("Cambiar propietario"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "migrate_project_dialog",
          attrs: { title: "Configurar migración", width: 850 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    color: "rgba(0,0,0,0.87)",
                    "font-size": "14px",
                  },
                },
                [
                  _c("span", { staticStyle: { "font-weight": "600" } }, [
                    _vm._v("Actual:"),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbots.data_center.metadata.vector_database")
                      ) + ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "500" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.item_selected.version_metadata &&
                          _vm.item_selected.version_metadata.datastores[0]
                            .database_service
                      )
                    ),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "chatbots.data_center.metadata.database_instance"
                        )
                      ) + ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "500" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.item_selected.version_metadata &&
                          _vm.item_selected.version_metadata.datastores[0]
                            .database_instance
                      )
                    ),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbots.data_center.metadata.embedding_source")
                      ) + ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "500" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.item_selected.version_metadata &&
                          _vm.item_selected.version_metadata.datastores[0]
                            .source_embedding
                      )
                    ),
                  ]),
                  _c("br"),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("chatbots.data_center.metadata.embedding")
                      ) + ":"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-weight": "500" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.item_selected.version_metadata &&
                          _vm.item_selected.version_metadata.datastores[0]
                            .tipo_embedding
                      )
                    ),
                  ]),
                ]
              ),
              _c(
                VForm,
                {
                  ref: "form_migration",
                  staticClass: "pt-2",
                  attrs: { id: "form_migration" },
                },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.vector_database"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.type_bd_vectorial,
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.dependent(
                                _vm.config_migration.source_embedding
                              ),
                            },
                            model: {
                              value: _vm.config_migration.database_service,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config_migration,
                                  "database_service",
                                  $$v
                                )
                              },
                              expression: "config_migration.database_service",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.database_instance"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.filteredInstances,
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.dependent(
                                _vm.config_migration.database_service
                              ),
                            },
                            model: {
                              value: _vm.config_migration.database_instance,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config_migration,
                                  "database_instance",
                                  $$v
                                )
                              },
                              expression: "config_migration.database_instance",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.embedding_source"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.type_embedding_source,
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.dependent(
                                _vm.config_migration.database_service
                              ),
                            },
                            model: {
                              value: _vm.config_migration.source_embedding,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config_migration,
                                  "source_embedding",
                                  $$v
                                )
                              },
                              expression: "config_migration.source_embedding",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "chatbots.data_center.metadata.embedding"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              items: _vm.filteredEmbeddings,
                              dense: "",
                              outlined: "",
                              filled: _vm.view,
                              disabled: _vm.view,
                              rules: _vm.rules.dependent(
                                _vm.config_migration.source_embedding
                              ),
                            },
                            model: {
                              value: _vm.config_migration.tipo_embedding,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.config_migration,
                                  "tipo_embedding",
                                  $$v
                                )
                              },
                              expression: "config_migration.tipo_embedding",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.edit || _vm.view == false
                ? _c(
                    VBtn,
                    {
                      staticClass: "primary mr-1",
                      on: {
                        click: function ($event) {
                          return _vm.migrateProject()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.save")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "change_bot_dialog",
          attrs: { title: "Cambiar bot", width: 600 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form_change_bot", attrs: { id: "form_change_bot" } },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v("Chatbot")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "10" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: _vm.rules.otros,
                              items: _vm.chatbots,
                              "item-value": "id",
                              "item-text": "name",
                            },
                            model: {
                              value: _vm.item_selected.chatbot,
                              callback: function ($$v) {
                                _vm.$set(_vm.item_selected, "chatbot", $$v)
                              },
                              expression: "item_selected.chatbot",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _vm.edit || _vm.view == false
                ? _c(
                    VBtn,
                    {
                      staticClass: "primary mr-1",
                      on: {
                        click: function ($event) {
                          return _vm.changeBot()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("btns.save")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }